function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import YoutubeVideoWithPosterComponentDefaultProps from "components/core/youtube-video-with-poster/default-props";
import { StyledEmbeddedYoutubeAssetComponent } from "./embedded-youtube-asset-component.scss";
import classnames from "classnames";
class EmbeddedYoutubeAssetComponent extends PureComponent {
    render() {
        const { fullWidth } = this.props;
        return /*#__PURE__*/ _jsx(StyledEmbeddedYoutubeAssetComponent, {
            className: classnames("embedded-youtube-asset-component", {
                "full-width": fullWidth
            }),
            style: this.getStyle(),
            children: /*#__PURE__*/ _jsx(YoutubeVideoWithPosterComponent, _object_spread_props(_object_spread({}, this.props), {
                fitToParent: true
            }))
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getStyle", ()=>{
            const { width, mobileWidth, isMobileOrTabletBrowser } = this.props;
            let finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
            finalWidth = finalWidth || "auto";
            return {
                width: finalWidth
            };
        });
    }
}
export { EmbeddedYoutubeAssetComponent as default };
EmbeddedYoutubeAssetComponent.defaultProps = _object_spread({}, YoutubeVideoWithPosterComponentDefaultProps);
